<template lang="pug">
.preview-page.setting-inner
  .summary-top
        .summary-top__info.info-summary
            .info-summary__ava К
            .info-summary__info
                .info-summary__title Меладзе в Рыбинске
                .info-summary__text Рыбинск, Дворец спорта "Полет", 16 октября, 19:00
  .preview-page__top
    h2.h2.setting-inner__h2 Настройки мероприятия
    a(href='#' @click.prevent="onSidebar" v-show="this.windowWidth < 1200").sidebar-gamb
      svgicon(name='gamb')
  form.form
      .setting-inner__flex
          .setting-inner__col
              h3.h3 Отложить старт продаж до
              .form__flex.form__flex--date
                  .form__group
                      label.form__label Дата старта
                      date-picker(v-model="dateStart" format="DD.MM.YYYY" :disabled-date="beforeDateEnd")

                  .form__group
                      label.form__label Время старта
                      v-select(
                          :options="hours"
                          :clearable="false"
                          :searchable="false"
                          :placeholder="'00'"
                      ).form__select.form__select--mini
                      span.points :
                      v-select(
                          :options="minutes"
                          :clearable="false"
                          :searchable="false"
                          :placeholder="'00'"
                      ).form__select.form__select--mini
                      span.form__info
                          svgicon(name="info" :fill="false")
                          .form__info-hidden Если кто-то захочет остановить обработку своих персональных данных, он свяжется с вами по указанным данным
                  .form__text Укажите дату и время для временной зоны Москвы (GMT+3)




          .setting-inner__col
              h3.h3 Отложить закрытие продаж до
              .form__group
                  .form__flex.form__flex--date
                      .form__group
                          label.form__label Дата завершения
                          date-picker(v-model="dateEnd" format="DD.MM.YYYY" :disabled-date="afterDateStart")
                      .form__group
                          label.form__label Время завершения
                          v-select(
                              :options="hours"
                              :clearable="false"
                              :searchable="false"
                              :placeholder="'00'"
                          ).form__select.form__select--mini
                          span.points :
                          v-select(
                              :options="minutes"
                              :clearable="false"
                              :searchable="false"
                              :placeholder="'00'"
                          ).form__select.form__select--mini
                          span.form__info
                              svgicon(name="info" :fill="false")
                              .form__info-hidden Если кто-то захочет остановить обработку своих персональных данных, он свяжется с вами по указанным данным
                      .form__text Укажите дату и время для временной зоны Москвы (GMT+3)

      .setting-inner__flex
          .setting-inner__col
              h3.h3 Билетов в корзине
              .form__group
                  label.form__label Количество
                  .form__full
                      v-select(
                          :options="this.tickets"
                          :clearable="false"
                          :placeholder="'Выберите количество билетов'"
                      ).form__select
                          template(v-slot:no-options) Извините, нет подходящих вариантов.
                      span.form__info
                          svgicon(name="info" :fill="false")
                          .form__info-hidden Если кто-то захочет остановить обработку своих персональных данных, он свяжется с вами по указанным данным

              h3.h3 Время жизни неоплаченного заказа
              .form__group
                  label.form__label Время
                  .form__full
                      v-select(
                          :options="this.time"
                          :clearable="false"
                          :placeholder="'Выберите время'"
                      ).form__select
                          template(v-slot:no-options) Извините, нет подходящих вариантов.
                      span.form__info
                          svgicon(name="info" :fill="false")
                          .form__info-hidden Если кто-то захочет остановить обработку своих персональных данных, он свяжется с вами по указанным данным

          .setting-inner__col
              //
                  h3.h3 Отключить бронирование в корзине
                  .form__group
                      p-check(name="visible-activity" value="Да" class="input-round p-svg p-round p-pulse" color="primary")
                          svgicon(name="check" class="svg")
                          | Да
                      span.form__info
                          svgicon(name="info" :fill="false")
                          .form__info-hidden Если кто-то захочет остановить обработку своих персональных данных, он свяжется с вами по указанным данным

              h3.h3 Бронь в корзине
              .form__group
                  label.form__label Время
                  .form__full
                      v-select(
                          :options="this.time"
                          :clearable="false"
                          :placeholder="'Выберите время'"
                      ).form__select
                          template(v-slot:no-options) Извините, нет подходящих вариантов.
                      span.form__info
                          svgicon(name="info" :fill="false")
                          .form__info-hidden Если кто-то захочет остановить обработку своих персональных данных, он свяжется с вами по указанным данным
      button.btn.btn--big Сохранить
</template>

<script>
import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
export default {
  name: 'settingActivity',
  data: function () {
    return {
      dateStart: null,
      dateEnd: null,
      windowWidth: null,
      tickets: [
        '1 билет',
        '2 билета',
        '3 билета',
        '4 билета',
        '5 билетов',
        '6 билетов',
        '7 билетов',
        '8 билетов',
        '9 билетов',
        '10 билетов',
        '11 билетов',
        '12 билетов',
        '13 билетов',
        '14 билетов',
        '15 билетов',
        '16 билетов',
        '17 билетов',
        '18 билетов',
        '19 билетов',
        '20 билетов'
      ],
      time: [
        'Выключить бронирование',
        '5 минут',
        '10 минут',
        '15 минут',
        '20 минут',
        '25 минут',
        '30 минут',
        '35 минут',
        '40 минут',
        '45 минут',
        '50 минут',
        '55 минут',
        '1 час'
      ]
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.resize);
      this.resize()
    })
  },
  methods: {
    ...mapMutations([
      'onSidebar',
    ]),
    beforeDateEnd(date) {
      if (this.dateEnd != null)
        return date > this.dateEnd;
    },
    afterDateStart(date) {
      if (this.dateStart != null)
        return date < this.dateStart;
    },
    resize() {
      this.windowWidth = document.documentElement.clientWidth;
    },
  },
  computed: {
    ...mapGetters([
      'hours',
      'minutes',
    ]),
  }
}
</script>

<style lang="scss">
.setting-inner{
  .h3{
    margin-top: 0;
  }
  &__h2{
    margin-top: 0;
    margin-bottom: 15px;
  }
  &__flex{
    display: flex;
    margin-bottom: 20px;
    .form__flex{
      margin-bottom: 20px;
    }
  }
  &__col{
    width: 510px;
    max-width: 100%;
    &:first-child{
      margin-right: 40px;
    }
  }
}
.preview-page__top{
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  .h2{
    margin-bottom: 5px;
  }
  .sidebar-gamb{
    margin-left: auto;
  }
}
@media (max-width: 1200px) {
  .setting-inner__flex{
    flex-direction: column;
  }
}
@media (max-width: 767px) {
  .setting-inner__col:first-child {
    margin-right: 0;
  }
  .setting-inner__content{
    padding: 30px 20px;
  }
  .setting-inner__flex {
    .form__input{
      width: 350px;
    }
  }
}
@media (max-width: 479px) {
  .setting-inner__flex {
    .form__input{
      width: calc(100% - 30px);
      box-sizing: border-box;
    }
  }
}
</style>